export const ModalTypes = Object.freeze({
    TextModal: 'text_with_button',
    IFrameModal: 'iframe'
});

